module.exports = __webpack_public_path__ + "img/postfight2a.96300c4e.jpg";